"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper class for evaluating "visible if" rules
 */
class VisibileIfEvaluator {
    /**
     * Compares values and returns whether they should be considered as equal.
     *
     * If one of values is an instance of number, both are converted to numbers before comparasion.
     *
     * @param value1 value 1
     * @param value2 value 2
     * @returns whether values should be considered as equal.
     */
    static compareValues(value1, value2) {
        if (value1 === value2) {
            return true;
        }
        if (value2 === null || value1 === null) {
            return false;
        }
        if (typeof value1 === "number") {
            if (typeof value2 === "string") {
                return parseFloat(value2) === value1;
            }
        }
        if (typeof value2 === "number") {
            if (typeof value1 === "string") {
                return parseFloat(value1) === value2;
            }
        }
        return value1 === value2;
    }
}
/**
 * Evaluates given visible if rule
 *
 * @param fieldRule rule
 * @param getFieldValue method for retrieving form values
 * @returns whether rule evaluated as visible or hidden
 */
VisibileIfEvaluator.isVisible = (fieldRule, getFieldValue) => {
    if (!fieldRule) {
        return true;
    }
    let result = false;
    const field = fieldRule.field;
    if (field && fieldRule.equals) {
        const equals = fieldRule.equals;
        const fieldValue = getFieldValue(field);
        result = VisibileIfEvaluator.compareValues(equals, fieldValue);
    }
    if (!result && field && fieldRule.notEquals) {
        const notEquals = fieldRule.notEquals;
        const fieldValue = getFieldValue(field);
        result = !VisibileIfEvaluator.compareValues(notEquals, fieldValue);
    }
    const ands = fieldRule.and || [];
    for (let i = 0; i < ands.length; i++) {
        if (!VisibileIfEvaluator.isVisible(ands[i], getFieldValue)) {
            return false;
        }
    }
    if (!result) {
        const ors = fieldRule.or || [];
        for (let i = 0; i < ors.length; i++) {
            if (VisibileIfEvaluator.isVisible(ors[i], getFieldValue)) {
                return true;
            }
        }
    }
    return result;
};
exports.default = VisibileIfEvaluator;
//# sourceMappingURL=data:application/json;base64,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